// chatService.js
import { GoogleGenerativeAI } from "@google/generative-ai";

const API_KEY = "AIzaSyD3yV_YREeaPTHd-krkWY-Vz6c87Gnb7EQ";
const genAI = new GoogleGenerativeAI(API_KEY);

// Converts a File object to a GoogleGenerativeAI.Part object
async function fileToGenerativePart(file) {
  const base64EncodedDataPromise = new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]);
    reader.readAsDataURL(file);
  });
  return {
    inlineData: { data: await base64EncodedDataPromise, mimeType: file.type },
  };
}
let chat;
export const startChat = async (initialHistory = []) => {
  const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

  chat = model.startChat({
    history: initialHistory,
    generationConfig: {},
  });

  return chat;
};

export const sendMessage = async (message, imageFile = null) => {

  let imageParts = [];
  if (imageFile) {
    imageParts = [await fileToGenerativePart(imageFile)];
  }

  const result = await chat.sendMessage([message, ...imageParts]);
  const response = await result.response;
  return response.text();
};
